(function () {
    'use strict';

    angular.module('swif.ui')
    .factory('swifDownloadService', swifDownloadService)
    .directive('swifDownloadFile', swifDownloadFile);


    function swifDownloadService() {
        //this is an empty service that we just use as singleton
        return {};
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifDownloadFile
    * @module swif.ui
    * @restrict E
    * @description handle the needed stuff to upload a file
    * (should it be renammed to swifUploadFile ?)
    * @usage
    * <swif-download-file></swif-download-file>
    **/
    function swifDownloadFile(dataService, swifDownloadService) {
        'ngInject';
        var download = swifDownloadService;
        return {
            restrict: 'E',
            scope:  {
                'swifDownloadFile': '='
            },
            link: function (scope, element) {
                scope.download = download;
                // Method which implements the download itself
                // we use an iframe containg an HTML form,
                // where each key,value of the data passed to directive is inserted as hidden input
                // finally, we submit() the form to perform the POST to the backend,
                // On the server response, the browser will automatically save the binary to the filesystem
                var downloadFile = function (data) {
                    //first, delete all existing iframe
                    var uniqueId = data.token;
                    var iframe = angular.element('<iframe style="display: none"></iframe>');
                    iframe.attr('name', uniqueId);

                    var form = angular.element('<form method="POST"></form>');
                    form.attr('target', uniqueId);
                    form.attr('action', data.url);
                    var values = angular.copy(data);
                    delete values.url;
                    _.forEach(values, function (val, key) {
                        var input = angular.element('<input type="hidden"/>');
                        input.attr('name', key);
                        input.val(val);
                        form.append(input);
                    });

                    iframe.append(form);
                    element.append(iframe);

                    iframe.load(function () {
                        form.remove();
                        iframe.remove();
                    });
                    form.submit();
                };
                // only reacts to variable (re-)assignation ONLY
                // for each re-assignation, perform the download file.
                //
                // In common use, you just have to implements this re-assignment
                // when you want the client to download the file
                scope.$watch('swifDownloadFile', function (newV, oldV) {
                    if(newV && newV !== oldV) {
                        downloadFile(newV);
                    }
                });
                scope.$watch('download.params', function (newV) {
                    if (newV) {
                        downloadFile(newV);
                    }
                });
            }
        };
    }

})();
